import '../../../../assets/css/screens/serviceprovider/dashboard/workerprofile/WorkerProfile.css';
import React, { useState, useRef, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Bell, MapPin, Star, Edit2, Phone, Mail, ShieldCheck,
  Home, Briefcase, Target, DollarSign, HelpCircle,
  Headphones, Settings, LogOut, ChevronRight, Camera,
  User, RefreshCw, X, AlertTriangle
} from 'lucide-react';
import Swal from 'sweetalert2';
import WorkerProfileSkeleton from "../../../../components/skeltonloading/WorkerProfileSkeleton";
import AppContext from '../../../../context/AppContext';
import axios from 'axios';
import KycRequiredModal from '../../../../components/serviceprovider/workerdashboard/kycrequired/KycRequiredModal';
import EditProfileModal from '../../../../components/serviceprovider/workerdashboard/workerprofile/EditProfileModal';
import SwitchModal from '../../../../components/serviceprovider/workerdashboard/workerprofile/SwitchModal';
import MobileHeader from '../../../../components/serviceprovider/workerdashboard/workerprofile/MobileHeader';
import WorkerHero from '../../../../subscreens/serviceprovider/dashboard/workerdashboard/workerprofile/WorkerHero';
import WorkerInfoCards from '../../../../components/serviceprovider/workerdashboard/workerprofile/WorkerInfoCards';
import WorkerExtraCards from '../../../../components/serviceprovider/workerdashboard/workerprofile/WorkerExtraCards';
import WorkerMenu from '../../../../components/serviceprovider/workerdashboard/workerprofile/WorkerMenu';
import WorkerLogout from '../../../../components/serviceprovider/workerdashboard/workerprofile/WorkerLogout';
/* ════ MAIN COMPONENT ════ */
const WorkerProfile = () => {
  const { baseUrl, authToken, setAuthToken, kycStatus, baseUrlForFile, RegExpChecker } = useContext(AppContext);
  const navigate = useNavigate();

  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [ssn, setSsn] = useState("");
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");

  const [bio, setBio] = useState("");
  // const [categoryId, setCategoryId] = useState("");
  const [ProfileImage, setProfileImage] = useState(null);
  const [jobsDone, setJobsDone] = useState(null);
  const [rating, setRating] = useState(null);
  const [reviews, setReviews] = useState(null);
  const [activeJobs, setActiveJobs] = useState(0);
  const [errors, setErrors] = useState({});
const [loading, setLoading] = useState(false);
const [pageLoading, setPageLoading] = useState(true);

  const [form, setForm] = useState({});
  const [loggedInWorker, setLoggedInWorker] = useState(null);
  const [preview, setPreview] = useState(null);

  const [editModal, setEditModal] = useState(false);
  const [switchModal, setSwitchModal] = useState(false);
  const [showKycModal, setShowKycModal] = useState(false);

  const [switchLoading, setSwitchLoading] = useState(false);

  const protectedRoutes = [
    "/bid-jobs",
    "/worker-earnings",
    "/worker-notifications",
    "/worker-support",
    "/worker-settings",      // 👈 Ye add karo
    "/subscription-history",
  ];

  const openEdit = () => setEditModal(true);
  const closeEdit = () => setEditModal(false);
  const [kycVerified, setKycVerified] = useState(false);
  const avatarRef = useRef();

  const clearFieldError = (field, value, setter) => {

    setter(value);

    setErrors((prev) => ({
      ...prev,
      [field]: ""
    }));

  };

  const validate = () => {

    const e = {};

    // Full Name
    if (!fullName.trim()) {

      e.fullName = "Full name is required";

    } else {

      const err = RegExpChecker("fullName", fullName);

      if (err.fullName)
        e.fullName = err.fullName;
    }

    // Email
    if (!email.trim()) {

      e.email = "Email is required";

    } else {

      const err = RegExpChecker("email", email);

      if (err.email)
        e.email = err.email;
    }

    // Phone
    if (!phoneNumber.trim()) {

      e.phone = "Phone number is required";

    } else {

      const err = RegExpChecker("phone", phoneNumber);

      if (err.phone)
        e.phone = err.phone;
    }

    return e;
  };
  // update profile

const updateProfile = async () => {
  const e = validate();
  if (Object.keys(e).length) {
    setErrors(e);
    return false;
  }
  const form = new FormData();
  form.append("fullName", fullName);
  form.append("email", email);
  form.append("phoneNumber", phoneNumber);
  form.append("ssn", ssn);
  form.append("city", city);
  form.append("address", address);
  form.append("bio", bio);
  const file = avatarRef.current?.files?.[0];
  if (file) {
    form.append("ProfileImage", file);
  }
  try {
    const res = await axios.post(
      `${baseUrl}/worker/updateprofile`,
      form,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          "Content-Type": "multipart/form-data"
        }
      }
    );
    const profile = res.data.serviceprovider;
    setKycVerified(res.data.kyc_status === "approved");
    setFullName(profile?.fullName || "");
    setEmail(profile?.email || "");
    localStorage.setItem("email", email);
    setPhoneNumber(profile?.phoneNumber || "");
    setSsn(profile?.ssn || "");
    setCity(profile?.city || "");
    setAddress(profile?.address || "");
    setBio(profile?.bio || "");
    if (profile?.ProfileImage) {
      setProfileImage(profile.ProfileImage);
    }
    return true;
  } catch (err) {
    const message = err.response?.data?.message;
    if (message === "Email already exists.") {
      setErrors(prev => ({
        ...prev,
        email: message
      }));
    }
    console.log(err);
    return false;
  }
};

  const handleProtectedNavigation = (path) => {

    if (
      kycStatus !== "approved" &&
      protectedRoutes.includes(path)
    ) {
      setShowKycModal(true);
      return;
    }

    navigate(path);
  };

  // view profile
 const viewProfile = async () => {
setPageLoading(true);
  try {

    const res = await axios.get(
      `${baseUrl}/worker/viewprofile`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`
        }
      }
    );

    console.log("WORKER PROFILE:", res.data);

    if (res.data.success) {

      const profile = res.data.serviceprovider;

      setFullName(profile?.fullName || "");
      setEmail(profile?.email || "");
      setPhoneNumber(profile?.phoneNumber || "");
      setSsn(profile?.ssn || "");
      setCity(profile?.city || "");
      setAddress(profile?.address || "");
      setBio(profile?.bio || "");

      setKycVerified(res.data.kyc_status === "approved");

      if (profile?.ProfileImage) {
        setProfileImage(
          `${baseUrlForFile}/${profile.ProfileImage}`
        );
      } else {
        setProfileImage(null);
      }

      setJobsDone(res.data.jobs_done);
      setActiveJobs(res.data.active_jobs);
      setRating(res.data.avg_rating);
      setReviews(res.data.total_reviews);
    }

  } catch (err) {

    console.log(
      "PROFILE ERROR:",
      err.response?.data || err.message
    );

  }
  finally{

        setPageLoading(false);

    }

};
  // sweet alert
const save = async () => {

    const e = validate();

    if (Object.keys(e).length) {
        setErrors(e);
        return;
    }

    setLoading(true);

    try {

        const success = await updateProfile();

        if (!success) return;

        await viewProfile();

        setEditModal(false);

        Swal.fire({
            icon: "success",
            title: "Updated",
            text: "Profile updated successfully."
        });

    } 
    finally {

        setLoading(false);

    }

};
  // logout with sweet alert
  const handleLogout = async () => {

    const result = await Swal.fire({
      title: 'Log Out?',
      text: 'Are you sure you want to logout?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ef4444',
      cancelButtonColor: '#6b7280',
      confirmButtonText: 'Yes, Logout',
      cancelButtonText: 'Cancel'
    });

    // sirf YES par logout hoga
    if (!result.isConfirmed) return;

    try {

      const res = await axios.post(
        `${baseUrl}/worker/logout`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`
          }
        }
      );


      console.log(res.data);

      if (res.data.success) {

        localStorage.removeItem("authToken");
        localStorage.removeItem("email");
        localStorage.removeItem("password");
        localStorage.removeItem("workerLoggedIn");

        setAuthToken("");

        await Swal.fire({
          icon: 'success',
          title: 'Logged Out',
          text: 'You have been logged out successfully',
          timer: 1500,
          showConfirmButton: false
        });

        navigate('/');

      }

    } catch (err) {

      console.log("LOGOUT ERROR:", err.response?.data || err.message);

      // Swal.fire({
      //   icon: 'error',
      //   title: 'Logout Failed',
      //   text: 'Something went wrong'
      // });

    }
  };
  // switch api
  const handleSwitchNow = async () => {
    if (switchLoading) return;

setSwitchLoading(true);
    try {
      const res = await axios.post(
        `${baseUrl}/worker/switchtocustomer`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`
          }
        }
      );
      console.log("SWITCH:", res.data);
      if (res.data.success) {

        localStorage.removeItem("authToken");
        localStorage.removeItem("workerLoggedIn");

        localStorage.setItem("authToken", res.data.customer_token);
        localStorage.setItem("customerLoggedIn", "true");

        setAuthToken(res.data.customer_token);

        setSwitchModal(false);

        navigate("/customer-dashboard");
      }
    } 
    
    catch (error) {

      console.log(
        "SWITCH ERROR:",
        error.response?.data || error
      );
      // Swal.fire({
      //   icon: "error",
      //   title: "Switch Failed",
      //   text: "Something went wrong"
      // });
      
    }
    finally {
    setSwitchLoading(false);
}
  };

  const handleHeroAvatar = (e) => {
    const file = e.target.files[0];

    if (file) {
      setProfileImage(file);
      setPreview(URL.createObjectURL(file));
      updateProfile();
    }
  };
  const change = (key, value) => {
    switch (key) {
      case "name": clearFieldError("fullName", value, setFullName); break;
      case "email": clearFieldError("email", value, setEmail); break;
      case "phone": clearFieldError("phone", value, setPhoneNumber); break;
      case 'ssn': setSsn(value); break;
      case 'city': setCity(value); break;
      case 'location': setAddress(value); break;
      case 'about': setBio(value); break;
      // case 'category': setCategoryId(value); break;

      default: break;
    }
  };
  useEffect(() => {
    viewProfile();
  }, []);
  if(pageLoading){
    return <WorkerProfileSkeleton />;
}
  /* ── Profile View ── */
  return (
    <div className="wp-page">
      {/* Mobile Header */}
      <MobileHeader navigate={navigate} />
      {/* Hero + Stats + Edit Button */}
      <WorkerHero
        avatarRef={avatarRef}
        ProfileImage={ProfileImage}
        preview={preview}
        handleHeroAvatar={handleHeroAvatar}
        fullName={fullName}

        // categoryId={categoryId}

        rating={rating}
        reviews={reviews}
        address={address}
        jobsDone={jobsDone}
        activeJobs={activeJobs}
        Earnings="$24.5K"
        openEdit={openEdit}
      />
      {/* Info Cards */}
      <WorkerInfoCards email={email} kycVerified={kycVerified} />
      {/* Switch to Customer */}
      <WorkerExtraCards setSwitchModal={setSwitchModal} />
      {/* Menu */}
      <WorkerMenu handleProtectedNavigation={handleProtectedNavigation} />
      {/* Logout */}
      <WorkerLogout handleLogout={handleLogout} />
      {/* Mobile Edit Modal */}
      {editModal && (
        <EditProfileModal
        loading={loading}
        errors={errors}
          form={{
            name: fullName,
            email,
            phone: phoneNumber,
            ssn: ssn,
            city,
            location: address,
            about: bio,


          }}
          avatarRef={avatarRef}
          ProfileImage={ProfileImage}
          setProfileImage={setProfileImage}
          onChange={change}
          onSave={save}
          onClose={closeEdit}
        />
      )}

      <KycRequiredModal
        isOpen={showKycModal}
        onClose={() => setShowKycModal(false)}
        onCompleteKyc={() => {
          setShowKycModal(false);
          navigate("/worker-kyc");
        }}
      />

      {/* Switch Modal */}
      {switchModal && (
        <SwitchModal
          onClose={() => setSwitchModal(false)}
          onSwitchNow={handleSwitchNow}
          switchLoading={switchLoading}
        />
      )}
    </div>
  );
};
export default WorkerProfile;